/*
 * File: OrderCard.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates the order summary information shown in lists
 */
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Divider, ListItem, ListItemText } from "@material-ui/core";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import OrderCardDetails from "./OrderCardDetails";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";

const styles = {
  cardHeader: {
    fontWeight: 500
  }
};

const OrderCard = ({ classes, order }) => {
  const checkUrgent = order => {
    if (order.urgent) return "red";
  };

  return useMemo(() => {
    const orderId = order.ordersId;
    const url = "/orders/" + orderId;
    const id = "link-to-order-" + orderId;
    return (
      <React.Fragment>
        <Link to={url} key={orderId} id={id}>
          <ListItem>
            <ListItemText
              primary={order.shortDescription}
              primaryTypographyProps={{
                className: classes.cardHeader,
                variant: "h6",
                style: { color: checkUrgent(order) }
              }}
              secondary={<OrderCardDetails order={order} />}
            />
            <ArrowRightIcon />
          </ListItem>
        </Link>
        <Divider />
      </React.Fragment>
    );
  }, [order, classes.cardHeader]);
};

OrderCard.propTypes = {
  order: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(OrderCard);
